import { TITLE_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Title implements TicketElement {
  text: string
  paddingTop: number
  paddingBottom: number
  boxHeight: number
  fontSize: number

  constructor(text: string, { fontSize, height }: { fontSize?: number; height?: number } = {}) {
    this.text = text
    this.paddingTop = 30
    this.paddingBottom = 20
    this.boxHeight = height || 60
    this.fontSize = fontSize || 30
  }

  height(): number {
    return this.paddingTop + this.boxHeight + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top, width, this.boxHeight)

    ctx.font = `bold ${this.fontSize}px ${TITLE_FONT}`
    if (ctx.measureText(this.text).width > width) {
      this.fontSize = Math.floor((this.fontSize * width) / ctx.measureText(this.text).width)
      ctx.font = `bold ${this.fontSize}px ${TITLE_FONT}`
    }

    ctx.fillStyle = 'white'
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'center'
    ctx.fillText(this.text, width / 2, top + this.boxHeight / 2)
  }
}
